// import axios from 'axios'
// state
const state = {
  notificationsData: null,
  notificationsReaded: null
}

// getters
const getters = {
  getNotificationsData (state) {
    return state.notificationsData
  },
  getReadedNotificationsData (state) {
    return state.notificationsReaded
  }
}

// actions
const actions = {
  // Update data notifications
  updateNotifications ({ commit, state }, data) {
    const store = this
    state.notifications = null
    let dataService = {
      method: 'GET',
      endpoint: '/api/dashboard/notifications',
      data: null,
      params: {
        size: '4',
        page: '1',
        country: 'ES',
        region: 'es-GC',
        city: 'es-LPA'
      },
      mutation: 'UPDATE_NOTIFICATIONS'
    }
    store.dispatch('callService', dataService)
  },
  // Update data notifications readed
  updateNotificationsReaded ({ commit, state }, data) {
    commit('UPDATE_NOTIFICATIONS_READED', data)
  }
}

// mutations
const mutations = {
  UPDATE_NOTIFICATIONS (state, data) {
    state.notificationsData = data
  },
  UPDATE_NOTIFICATIONS_READED (state, data) {
    state.notificationsReaded = data
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/notifications.js